/**
 * icons.jsx — mapa compartido string → componente lucide-react para la landing.
 * Fuente única del componente <Icon name="..." />, reusado por LandingPage y por GirosDiagram
 * (evita duplicar el mapa). Los `icon` de data.js (MODULES, STEPS, VERTICALS) usan estas claves.
 */
import {
  BarChart3, Bot, Building2, Car, GitBranch, Globe, GraduationCap,
  HeartPulse, Inbox, Layers, Mail, Store, User, UserPlus, Users, Wand2, Workflow,
  PhoneIncoming, PhoneOutgoing, AudioLines, PhoneCall, Radar, MessageCircle,
  LayoutTemplate, Facebook, Webhook, Package, Home, Map, Wrench, Tags, Library,
  CalendarCheck, Shuffle, Megaphone, RadioTower, Waypoints, Contact, Columns3,
  ListTodo, TrendingUp, BadgeDollarSign, Compass, FileBarChart, CreditCard,
  LayoutDashboard,
} from 'lucide-react';

export const ICON_MAP = {
  BarChart3, Bot, Building2, Car, GitBranch, Globe, GraduationCap,
  HeartPulse, Inbox, Layers, Mail, Store, User, UserPlus, Users, Wand2, Workflow,
  PhoneIncoming, PhoneOutgoing, AudioLines, PhoneCall, Radar, MessageCircle,
  LayoutTemplate, Facebook, Webhook, Package, Home, Map, Wrench, Tags, Library,
  CalendarCheck, Shuffle, Megaphone, RadioTower, Waypoints, Contact, Columns3,
  ListTodo, TrendingUp, BadgeDollarSign, Compass, FileBarChart, CreditCard,
  LayoutDashboard,
};

export function Icon({ name, className }) {
  const Cmp = ICON_MAP[name];
  if (!Cmp) return null;
  return <Cmp className={className} />;
}
